var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { VueType, Component } from '../core';
import { IHistoryState } from '../../store/HistoryState';
import HistoryMod from './HistoryMod';
import './history.style.scss';
import { Watch } from 'vue-property-decorator';
import { ls } from '../../../common/utils';
import RecChannel from '../common/rec/RecChannel';
import IconBtn from '../components/IconBtn';
import { dialog } from '../../../common/dialog';
import { domEvent } from '../../../common/scroll';
import { toast } from '../../../common/toast';
import { checkLogin } from '../../../common/decorators';
let History = class History extends VueType {
    constructor() {
        super(...arguments);
        /**
           * 过滤已看完
           */
        this.isFiterWatched = true;
    }
    get modList() {
        return this.state.modList;
    }
    get isHasData() {
        return this.state.modList.some(item => !!item.ids.length);
    }
    get deleteAllDtParams() {
        return '';
    }
    created() {
        this.isFiterWatched = this.state.isFiterWatched;
        this.showToast();
    }
    mounted() {
        this.state.loadData(true);
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const self = this;
        $(this.$parent.$el).on('click', '[data-del]', function (e) {
            e.stopPropagation();
            const $el = $(this);
            const rid = $el.data('del');
            self.state.delOneHistory(rid);
            return false;
        });
        domEvent.bottom.on(this.loadMore);
    }
    activated() {
        domEvent.bottom.on(this.loadMore);
    }
    deactivated() {
        domEvent.bottom.off(this.loadMore);
    }
    beforeDestroy() {
        domEvent.bottom.off(this.loadMore);
    }
    onFiterWatchedChange() {
        this.state.changeFiter(this.isFiterWatched);
    }
    loadMore() {
        if (txv.login.isLogin()) {
            this.state.loadData();
        }
    }
    onDelAllClick() {
        return __awaiter(this, void 0, void 0, function* () {
            const res = yield dialog.confirm({ title: '确认清除所有观看记录吗？' });
            if (res.isOK) {
                this.state.delAllHistory();
            }
        });
    }
    // 对于第一次进入的用户，需要提示观看历史的变化
    showToast() {
        const tagKey = 'historyToastShown';
        const toastShown = ls.get(tagKey);
        if (toastShown) {
            return;
        }
        toast.show({ text: '观看历史数据升级啦，我们将会记录你看过的完整版内容，喜欢的短视频内容可以使用“收藏”来记录哦', duration: 4000 });
        ls.set(tagKey, true);
    }
    render() {
        let dom = null;
        if (this.isHasData) {
            dom = (<div class="wrapper_main history_page">
                    <div class="history_filter_box">
                        {this.state.hasData
                && <IconBtn onClick={this.onDelAllClick} class="history_clear" text='清除全部' dt-eid="button" dt-params="title=delete_all"></IconBtn>}
                    </div>
                    {this.modList.map((mod, index) => <HistoryMod mod={mod} key={mod.type} index={index}></HistoryMod>)}
                    <p class="history_tip">最多展示近一年前500条记录</p>
                </div>);
        }
        else {
            dom = <RecChannel title="你还没有任何观看记录,不如试试这些专属推荐"></RecChannel>;
        }
        return <div>
            {(this.state.isHasFetched || !txv.login.isLogin()) && dom}
        </div>;
    }
};
__decorate([
    IHistoryState
], History.prototype, "state", void 0);
__decorate([
    checkLogin
], History.prototype, "created", null);
__decorate([
    Watch('isFiterWatched')
], History.prototype, "onFiterWatchedChange", null);
History = __decorate([
    Component
], History);
export default History;
